import React from "react";
import SelectionCriteria from "../../../../../../JsonScreen/Screen/ScreenComponents/SelectionCriteria/SelectionCriteria";

const SelectionCriteriaComponent = () => {

    return (
        <>
            <SelectionCriteria
                disabled
                asComponent
                globalValues={{param: {}}}
                screenName={''}
            />
        </>
    )
};
export default SelectionCriteriaComponent;